import styles from './ADengiDisclaimer.module.scss';

export function ADengiDisclaimer({ heading, subheading }: { heading?: string; subheading?: string }) {
  if (!heading && !subheading) {
    return null;
  }
  return (
    <div className={styles.content}>
      {heading && <span className={styles.heading}>{heading}</span>}
      {subheading && <span className={styles.heading}>{subheading}</span>}
    </div>
  );
}
